
declare var Object: any;
export interface LastFileViewInterface {
  "id": number;
  "documentId": number;
  "uploadedById": number;
  "container": string;
  "originalFilename": string;
  "filename": string;
  "uploadedAt": Date;
  "dtime"?: Date;
  "dtime_str"?: string;
}

export class LastFileView implements LastFileViewInterface {
  "id": number;
  "documentId": number;
  "uploadedById": number;
  "container": string;
  "originalFilename": string;
  "filename": string;
  "uploadedAt": Date;
  "dtime": Date;
  "dtime_str": string;
  constructor(data?: LastFileViewInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `LastFileView`.
   */
  public static getModelName() {
    return "LastFileView";
  }

  /**
  * This method creates an instance of LastFileView for dynamic purposes.
  **/
  public static factory(data: LastFileViewInterface): LastFileView{
    return new LastFileView(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LastFileView',
      plural: 'LastFileViews',
      path: 'LastFileViews',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "documentId": {
          name: 'documentId',
          type: 'number'
        },
        "uploadedById": {
          name: 'uploadedById',
          type: 'number'
        },
        "container": {
          name: 'container',
          type: 'string'
        },
        "originalFilename": {
          name: 'originalFilename',
          type: 'string'
        },
        "filename": {
          name: 'filename',
          type: 'string'
        },
        "uploadedAt": {
          name: 'uploadedAt',
          type: 'Date'
        },
        "dtime": {
          name: 'dtime',
          type: 'Date'
        },
        "dtime_str": {
          name: 'dtime_str',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}
